import { Component, Input, SimpleChanges } from '@angular/core';
import { ProponenteService } from 'administrativo-lib';
import {
  BaseResourceItemsComponent,
  Contrato, ContratoRenegociacao,
  ContratoRenegociacaoItem,
  DateFormatPipe,
  FuncaoService,
  GlobalService
} from 'eddydata-lib';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { ContratoRenegociacaoService } from '../service/contrato-renegociacao.service';

declare var $: any;

@Component({
  selector: 'lib-contrato-renegociacao',
  templateUrl: './contrato-renegociacao.component.html'
})
export class ContratoRenegociacaoComponent extends BaseResourceItemsComponent<ContratoRenegociacao> {

  public ptBR: any;
  public itemAtual: ContratoRenegociacao;
  public visualizar_item: boolean;
  public listaRenegociacao: ContratoRenegociacao[] = [];
  public inabilitarBotao = false;

  @Input() public contrato: Contrato;
  @Input() visualizarC: Boolean = false;


  imaskConfig = {
    mask: Number,
    scale: 2,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    protected globalService: GlobalService,
    public funcaoService: FuncaoService,
    public proponenteService: ProponenteService,
    public renegociacaoService: ContratoRenegociacaoService) {
    super(new ContratoRenegociacao(), renegociacaoService);
  }

  protected afterInit(): void {
    this.ptBR = this.globalService.obterDataBR();
  }

  protected validSave(item: ContratoRenegociacao): boolean {
    if (!item.data_contabilizacao) {
      toastr.warning(`Informe a data de contabilização da renegociação de ${item.contrato_recebido?.favorecido?.nome || 'identificador desconhecido'}!`);
      return false;
    }
    if (!item.data_renegociacao) {
      toastr.warning(`Informe a data da renegociação de ${item.contrato_recebido?.favorecido?.nome || 'identificador desconhecido'}!`);
      return false;
    }
    if (!item.motivo) {
      toastr.warning(`Informe o motivo da renegociação de ${item.contrato_recebido?.favorecido?.nome || 'identificador desconhecido'}!`);
      return false;
    }
    if (!this.funcaoService.podeAlterarAudesp(item.data_contabilizacao, this.login)) {
      toastr.warning(`Não é possível alterar a renegociação de ${item.contrato_recebido?.favorecido?.nome || 'identificador desconhecido'}. Prazo esgotado!`);
      return false;
    }
    return true;
  }

  protected beforeSave(item: ContratoRenegociacao): void { }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public async adicionar() {
    this.visualizar_item = false;
    this.itemAtual = null;
    this.listaRenegociacao = [];
    $('#dialogRenegociacao').modal('show');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.lista) {
      this.lista = this.lista.sort((a, b) => { return +new Date(a.data_renegociacao) - +new Date(b.data_renegociacao) });
    }
  }

  public verificarSaldoBotao() {
    if (this.contrato.id) {
      const valorTotal = this.contrato.itens.reduce((soma, item) => {
        return soma + (item['saldo_qtd'] * item.vl_unit_atualizado);
      }, 0);

      return valorTotal <= 0;
    }
  }

  public ordernarLista(event) {
    console.log(this.contrato)
    this.renegociacaoService.filtrar(1, -1, {
      'OR': `contrato_enviado.id=${this.contrato.id};!;!;contrato_recebido.id=${this.contrato.id}`,
      relations: 'usuario,itens.contrato_enviado_item.produto_unidade.produto,contrato_enviado.favorecido,contrato_recebido.favorecido',
      orderBy: 'data_renegociacao$DESC'
    })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.lista = res.content;
      });
  }


  // public editar(item: ContratoRenegociacao) {
  //   this.visualizar_item = false;
  //   this.itemAtual = item;
  //   // this.entity.editavel = true;
  //   this.itemAtual.data_renegociacao = new DateFormatPipe().transform(item.data_renegociacao, []);
  //   this.itemAtual.data_contabilizacao = new DateFormatPipe().transform(item.data_contabilizacao, []);
  //   this.itemAtual.itens.map(itm => itm.contrato_env_item['cota'] = this.retornaCota(itm, item.itens) === 'P' ? 'PRINCIPAL' : 'RESERVADO')
  //   $('#dialogRenegociacao').modal('show');
  // }

  public visualizar(item: ContratoRenegociacao) {
    this.itemAtual = { ...item };
    this.itemAtual.data_renegociacao = new DateFormatPipe().transform(item.data_renegociacao, []);
    this.itemAtual.data_contabilizacao = new DateFormatPipe().transform(item.data_contabilizacao, []);
    this.visualizar_item = true;
    $('#dialogRenegociacao').modal('show');
  }

  public condicaoEdicao(item: ContratoRenegociacao): Boolean {
    // const hoje = Date.now()
    // return this.funcaoService.converteDataSQL(new Date(hoje)) <= this.funcaoService.converteDataSQL(new Date(item.data_contabilizacao))

    const diasBloqueio = this.login.parametro.contabil?.dias_bloquear_alteracoes
    const dataAudesp = this.login.ultimoAudesp
    const dataContabilizacao = this.funcaoService.zerarHoras(new Date(item.data_contabilizacao))


    const dataLimiteSuperior = this.funcaoService.adicionarDia(diasBloqueio, this.funcaoService.zerarHoras(new Date()))
    const dataLimiteInferior = this.funcaoService.adicionarDia(diasBloqueio, this.funcaoService.zerarHoras(new Date()), false, true)

    if (dataContabilizacao >= dataLimiteSuperior || dataContabilizacao <= dataLimiteInferior) {
      return false
    } else {
      const mes = +dataAudesp.split('-')[1]
      const ano = +dataAudesp.split('-')[0]

      if ((dataContabilizacao.getFullYear() < ano || (dataContabilizacao.getFullYear() === ano && (+dataContabilizacao.getMonth() + 1) <= mes)) && mes < 12) {
        return false
      } else {
        return true
      }
    }
  }

  public retornaCota(itemAtual: ContratoRenegociacaoItem, lista: ContratoRenegociacaoItem[]) {
    let cota: 'P' | 'R'
    if (itemAtual.contrato_enviado_item.memorial) {
      cota = itemAtual.contrato_enviado_item.memorial.cota === 'PRINCIPAL' ? 'P' : itemAtual.contrato_enviado_item.memorial.cota === 'NAO_DEFINIDO' ? 'P' : 'R'
    } else {
      let itemIgual = lista.find(it => it.contrato_enviado_item.produto_unidade.id === itemAtual.contrato_enviado_item.produto_unidade.id && it.id !== itemAtual.contrato_enviado_item.id)
      cota = !itemIgual ? 'P' : +itemAtual.contrato_enviado_item.quantidade > +itemIgual.contrato_enviado_item.quantidade ? 'P' : 'R'
    }
    return cota
  }

  public podeVisualizar() {
    if (this.visualizarC === true) {
      return true;
    }
    if (this.visualizarC === false) {
      return false;
    }
  }
}